"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var checkSufficientRdeProps = function (params) {
    var rdeType = params.rdeType;
    /** settings represent the props that are required for each GraphQL request */
    var settings = {
        prudSysProducts: ['cid', 'articleNo'],
        prudSysProductsSimilar: ['articleNo'],
        prudSysAddToBasket: ['articleNo', 'cid'],
        prudSysSearchTerm: ['searchTerm'],
        prudsysHomePage: [],
        alternativeProducts: ['articleNo'],
        criteoProducts: ['price', 'articleNo'],
        seriesProducts: [],
    };
    /**
     * iterates over each param from settings and checks if provided param from `params` has the correct value.
     * if not it is passed back to check and therefore the check array has a length > 0
     */
    var check = settings[rdeType].filter(function (param) {
        if (param !== 'price') {
            return params[param] === '';
        }
        return params[param] === -1;
    });
    /**
     * if the length from check is > 0, one of the passed params has a wrong value
     */
    if (check.length > 0) {
        // eslint-disable-next-line no-console
        console.error("You have to specify " + check.join(', ') + " for " + rdeType + " to work.");
    }
    return check.length === 0;
};
exports.default = checkSufficientRdeProps;
//# sourceMappingURL=checkSufficientRdeProps.js.map